import { Component, OnInit } from '@angular/core';
import { ToasterService } from 'angular5-toaster';
import { TramApiService } from '../tram-api.service';
import { User } from '../core/user';
import { StorageService } from '../storage.service';
import { State } from '../core/state';
import { UserTicket, UserTicketTrip } from '../core/userTicket';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';

class UserAccountTicket extends UserTicket {
    public isExpanded?: boolean;
}

@Component({
    selector: 'account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {
    state: State;
    readonly requestLimit = 10;

    isRegistration: boolean;
    isAuthenticated: boolean;
    user: User;
    tickets: UserAccountTicket[];

    constructor(private api: TramApiService,
        private storage: StorageService,
        private formBuilder: FormBuilder,
        private toaster: ToasterService) {
        storage.isSensitiveDataExist.subscribe(v => {
            if (this.isAuthenticated === v)
                return;

            this.isAuthenticated = v;

            if (this.isAuthenticated) {
                this.loadTickets()
            } else {
                this.tickets = [];
            }
        });
    }

    ngOnInit() {
        this.tickets = [];
        if (this.isAuthenticated === this.storage.isSensitiveDataExist.getValue())
            return;

        this.isAuthenticated = this.storage.isSensitiveDataExist.getValue();

        if (this.isAuthenticated) {
            this.loadTickets();
        }
    }

    toggleTab(isRegistrationTabClicked: boolean) {
        if (this.isRegistration === isRegistrationTabClicked)
            return;

        this.isRegistration = !this.isRegistration;
    }

    logout() {
        if (this.isAuthenticated && this.storage.isSensitiveDataExist.value === true)
            this.storage.clear();
    }

    wrappedGetMoreTickets = (offset: number = 0) => {
        return this.loadTickets(offset);
    }

    toggleTicket(ticket: UserAccountTicket) {
        const expand = !ticket.isExpanded;
        if (expand) {
            this.tickets.forEach(t => t.isExpanded = false);
        }
        ticket.isExpanded = expand;
    }

    private loadTickets(offset: number = 0): Promise<any> {
        let token = this.storage.getToken();

        return this.api.getCurrentUser()
            .then(u => {
                this.user = u;
                return this.api.getUserTickets(this.user.id, this.requestLimit, offset)
                    .then(response => {
                        this.state = response.state;

                        response.data.forEach(t => {
                            this.tickets.push(t);
                        });

                        return response;
                    });
            })
            .catch(err => this.handleError(err));
    }

    private loadTicket(ticket: UserTicket) {
        this.api.getTicket(ticket.id)
            .then(ticket => {
                this.tickets.some(t => {
                    if (t.id === ticket.id) {
                        t.trips = ticket.trips;
                        t.remainingTripsCount = ticket.remainingTripsCount;
                        t.updated = ticket.updated;
                        return true;
                    }
                    return false;
                });
            }).catch(err => this.handleError(err));
    }

    private handleError(error: HttpErrorResponse | string) {
        if (error instanceof HttpErrorResponse) {
            this.toaster.pop('error', null, error.statusText);
        } else {
            this.toaster.pop('error', null, error);
        }
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/account.component.ts